import { hashStringToSeed, pickFromHash } from '../derive';
import { parseDotStudioHeroMarker } from './hero-cover-marker';
import { generateHeroCoverPickerOptions, type RandomDotStudioPattern } from './randomize-pattern';

/** Mulberry32 — stable deterministic RNG from a 32-bit seed. */
export function rngFromSeed(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Deterministic hero cover recipe for a user — same `userId` always yields the
 * same variant, seed text, and density-field overrides.
 */
export function heroCoverForUser(userId: string): RandomDotStudioPattern {
  const options = generateHeroCoverPickerOptions(rngFromSeed(hashStringToSeed(userId)));
  return pickFromHash(options, userId);
}

/** Marker URL from profile save, else deterministic default for `userId`. */
export function resolveHeroCoverPattern(
  userId: string,
  heroUrl: string | null | undefined,
): RandomDotStudioPattern {
  return parseDotStudioHeroMarker(heroUrl) ?? heroCoverForUser(userId);
}
